<script setup lang="ts">
import { NewProduct, NewProductModification } from '@/types/api/api-v4/product'
import { ProductParentType } from '@/types/components/product-card.types'

import ProductTagElements from '@/components/Product/ProductTags/ProductTagElements.vue'
import ProductTagRating from '@/components/Product/ProductTags/ProductTagRating.vue'
import ProductTags from '@/components/Product/ProductTags/ProductTags.vue'

type Props = {
  product: NewProduct
  currentModification: NewProductModification
}

defineProps<Props>()

const { isDesktop } = useResponsive()
</script>

<template>
  <div class="image-tags">
    <product-tag-elements
      :product="product"
      :type="ProductParentType.detail"
      size="md"
    />

    <product-tag-rating
      :rating="product.rating"
      :type="ProductParentType.detail"
      size="md"
    />

    <product-tags
      v-if="isDesktop"
      :main-tags="product.main_tags"
      :additional-tags="product.additional_tags"
      :current-modification="currentModification"
      :type="ProductParentType.detail"
    />
  </div>
</template>

<style scoped lang="scss">
.image-tags {
  display: flex;
  gap: 4px;
}
</style>
